/**
 * AI Chat Button
 * Floating action button that opens the AI chat drawer. Sits at z-30 so the
 * mobile sidebar and its backdrop (z-40/50) cover it.
 */

import { MdAutoAwesome } from "react-icons/md";
import { Tooltip } from "components/tooltip";

const AIChatButton = ({ onClick, isOpen = false }) => {
  if (isOpen) {
    return null; // Hidden while the drawer is open
  }

  return (
    <Tooltip
      placement="left"
      content="Atrium AI"
      trigger={
        <button
          type="button"
          onClick={onClick}
          aria-label="Open Atrium AI"
          className="focus-ring group fixed bottom-6 right-6 z-30 flex h-14 w-14 items-center justify-center rounded-full bg-primary text-primary-fg shadow-overlay transition-colors hover:bg-primary-hover"
        >
          <MdAutoAwesome
            aria-hidden="true"
            className="h-6 w-6 transition-transform motion-safe:group-hover:scale-110"
          />
        </button>
      }
    />
  );
};

export default AIChatButton;
